import { createContext } from 'react';
import { Path, DropdownProps, DropdownActions } from './Dropdown';
import { State } from './DropdownContext';
import { PanelActions } from './Panel';

export enum PanelActionTypes {
  SET_ARROW_DIRECTION = 'SET_ARROW_DIRECTION',
  SET_FILTER_HTML_VALUE = 'SET_FILTER_HTML_VALUE',
  SET_FILTER_STRING = 'SET_FILTER_STRING',
  SET_IS_ACTIONS_FOCUSED = 'SET_IS_ACTIONS_FOCUSED',
  SET_PAGE = 'SET_PAGE',
  SET_PARENT_NAME = 'SET_PARENT_NAME',
  SET_PATH = 'SET_PATH',
}

export interface PanelState {
  /** The direction to look for enabled options if focus failed on a disabled option */
  arrowDirection: string;
  /** The html value of the filter input itself. */
  filterHtmlValue: string;
  /** The user's typed input which options are filtered by  */
  filterString: string;
  isActionsFocused: boolean;
  page: number;
  parentName: string;
  path: Path[];
}

export const initialPanelState: PanelState = {
  arrowDirection: 'down',
  filterHtmlValue: '',
  filterString: '',
  isActionsFocused: false,
  page: 0,
  parentName: '',
  path: [],
};

interface Action {
  payload: string | boolean | number | Path[];
  type: string;
}

export function panelReducer(state = initialPanelState, { payload, type }: Action) {
  switch (type) {
    case PanelActionTypes.SET_ARROW_DIRECTION:
      return { ...state, arrowDirection: payload as string };
    case PanelActionTypes.SET_FILTER_HTML_VALUE:
      return { ...state, filterHtmlValue: payload as string };
    case PanelActionTypes.SET_FILTER_STRING:
      return { ...state, filterString: payload as string };
    case PanelActionTypes.SET_IS_ACTIONS_FOCUSED:
      return { ...state, isActionsFocused: payload as boolean };
    case PanelActionTypes.SET_PAGE:
      return { ...state, page: payload as number };
    case PanelActionTypes.SET_PARENT_NAME:
      return { ...state, parentName: payload as string };
    case PanelActionTypes.SET_PATH:
      return { ...state, path: payload as Path[] };
    default:
      return state;
  }
}

export interface IPanelContext {
  dropdownActions?: Partial<DropdownActions>;
  dropdownProps?: DropdownProps;
  dropdownState?: State;
  panelActions?: PanelActions;
  panelState: PanelState;
  uniqueId?: string;
}

const PanelContext = createContext<IPanelContext>({
  panelState: { ...initialPanelState },
});

export default PanelContext;
